import Accordion from "accordion-js";

document.addEventListener("DOMContentLoaded", () => {
	const accordion = new Accordion(".accordion-link", {
		duration: 300,
		showMultiple: true,
	});
});

document.querySelector(".open-accordion")?.addEventListener("click", () => {
	const trigger = document.querySelector(".accordion-link .ac-trigger");
	if (trigger) trigger.click();
});
